module.exports = __webpack_public_path__ + "static/img/zijianComputer.c66aea41.jpg";